module.exports = new __parcel__URL__("blob_consmetic_icon.f05bb7a4.png").toString();